import { FunctionComponent } from 'react'
import profileStyles from '../DaycareProfileHandler.module.scss'
import Levels from './modals/levels'
import { Daycare } from '@/types/Daycare'
import StaffRate from './modals/staffRate'
import { useTranslation } from 'react-i18next'
import ButtonTextIcon from '@/components/_custom/Buttons/ButtonTextIcon/ButtonTextIcon'
import GroupsIcon from '@mui/icons-material/Groups'
import { NavigateFunction, useNavigate } from 'react-router-dom'
import { useAuth } from '@/modules/context/AuthContext.tsx'
import StaffPreparationTaskComponent from './modals/staffPreparationTask'

interface DaycareStaffSettingsProps {
    daycare: Daycare
}

const DaycareStaffSettings: FunctionComponent<DaycareStaffSettingsProps> = ({ daycare }: DaycareStaffSettingsProps) => {
    const { user } = useAuth()

    const { t } = useTranslation()

    const navigate: NavigateFunction = useNavigate()

    const canUpdate: boolean = !!user?.currentDaycareRights.canWriteParamsDaycare

    return (
        <div className={profileStyles.PagePosition}>
            <Levels daycare={daycare} canUpdate={canUpdate} />
            {user?.currentDaycareRights.hasStaffAccess && <StaffRate daycare={daycare} canUpdate={canUpdate} />}
            {user?.currentDaycareRights.hasStaffAccess && <StaffPreparationTaskComponent daycare={daycare} />}
            {user?.currentDaycareRights.hasStaffAccess && user.currentDaycareRights.canReadStaffRights && (
                <ButtonTextIcon
                    type={'custom'}
                    customText={t('showStaffList')}
                    onClick={() => navigate(`/staff?daycare=${daycare.id}`)}
                    customIcon={<GroupsIcon />}
                />
            )}
        </div>
    )
}

export default DaycareStaffSettings
